export default __webpack_public_path__ + "static/033-ee7c1222435d5f7a0b80a2eb494018e3.png";